export const SET_CART = "cart/SET";
export const ADD = "cart/ADD";
export const CHANGE_QUANTITY = "cart/CHANGE_QUANTITY";
export const REMOVE = "cart/REMOVE";
export const CLEAR = "cart/CLEAR";